import { NavigationMockApi } from './common/navigation/api';

export const mockApiServices = [NavigationMockApi];
